import { Fragment, useImperativeHandle, useRef } from "react";
import { useSelector } from "react-redux";
import { InputBlank } from "../Blank";
import classes from './TextController.module.scss';
import { COMPLETAR_SOUNDS, QUESTION_TYPE } from "../../utils/constants.js";
import clsx from "clsx";
import { DropzoneBlank } from "../DropzoneBlank/index.jsx";
import { useAnimate, motion } from "framer-motion";
import { useGameSounds } from "@educaplay/core";
import { Dropdown } from "../Dropdown/index.jsx";

const diccionario = {
    [QUESTION_TYPE.DND]: DropzoneBlank,
    [QUESTION_TYPE.WRITTING]: InputBlank,
    [QUESTION_TYPE.DROPDOWN]: Dropdown
}

export const TextController = (props) => {
    const { onChange, onFocus, onBlur, gameState, setGameState, clickBlankHandler, activeId, setActiveId, animated, ref } = props;
    const question = useSelector(state => state.game.questions[state.game.currentIndex]);
    const Blank = diccionario[question.questionType];
    const isAnimating = useSelector(state => state.game.isAnimating);

    const gameSounds = useGameSounds();

    const [containerRef, animateContainer] = useAnimate();
    const wordRefs = useRef({});

    useImperativeHandle(ref, () => ({
        entryAnimation: async (options = {}) => {
            await animateContainer(containerRef.current, { scale: 1 }, {
                type: "tween",
                duration: 0.5,
                ease: [0.25, 1, 0.5, 1],
                ...options
            });
        },
        getWordRef: (id) => wordRefs.current[id]
    }));

    const removeWord = (id) => {
        if (isAnimating) return;
        gameSounds.play(COMPLETAR_SOUNDS.MOVE)
        const blankId = gameState.idBlanks.find(blank => blank.fill === id)?.id;
        const newGameState = {
            ...gameState,
            words: gameState.words.map(word => {
                if (word.id === id) {
                    return {
                        ...word,
                        used: false,
                        isCorrect: null
                    }
                }
                return word;
            }),
            idBlanks: gameState.idBlanks.map(blank => {
                if (blank.id === blankId) {
                    return {
                        ...blank,
                        fill: null,
                        isCorrect: null
                    }
                }
                return blank;
            })
        }
        setGameState(newGameState);
        if (blankId) setActiveId(blankId)
    }

    return (
            <motion.div 
                ref={containerRef}
                initial={{ scale: animated ? 0 : 1 }}
                className={clsx(classes.textWrapper, question.questionType === QUESTION_TYPE.WRITTING && classes.writting, classes.scrollbar)}
            >
                {question.formattedText.map((block, pIndex) => (
                    <div key={pIndex} className={clsx(classes.paragraph)}>
                        {block.map((block, index) => (
                            <Fragment key={index}>
                                {block.isGap ? (
                                    <span className={classes.blankWrapper}>
                                        <Blank
                                            ref={el => wordRefs.current[block.id] = el}
                                            key={block.id}
                                            handleOnChange={onChange}
                                            onFocus={onFocus}
                                            onBlur={onBlur}
                                            gameState={gameState}
                                            setGameState={setGameState}
                                            blankId={block.id}
                                            clickBlankHandler={clickBlankHandler}
                                            clickWordHandler={removeWord}
                                            activeId={activeId}
                                        />
                                    </span>
                                ) : (
                                    <span>{block.data}</span>
                                )}
                            </Fragment>
                        ))}
                    </div>
                ))}
            </motion.div>
    )
}